import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';

interface NavItemType {
  key?: number | string;
  $hasError?: boolean;
  $active?: boolean;
  disabled?: boolean;
}

export const NavItem = styled.div.attrs<NavItemType>(props => ({
  className:
    (props.$active && 'active') || (props.disabled && 'disabled') || '',
}))<NavItemType>`
  cursor: pointer;
  padding: 16px 32px;
  color: ${colors.textOnInvertedSubtle};
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 24px;
  ${props =>
    props.$hasError &&
    css`
      padding-right: 16px;
    `}
  &:hover, &.active {
    color: ${colors.textModerate};
    background-color: ${colors.grey200};
  }
  &.disabled {
    cursor: default;
    color: ${colors.textDisabled};
    &:hover {
      color: ${colors.textDisabled};
      background-color: transparent;
    }
  }
`;
